import { useTranslate } from '@refinedev/core';
import { Form, Modal, Select } from 'antd';
import {
  ReviewRejectionReason,
  type ReviewRejectIn,
} from '@/api/generated/schemas';

interface RejectReviewModalProps {
  open: boolean;
  submitting: boolean;
  onCancel: () => void;
  onSubmit: (reason: ReviewRejectionReason) => void;
}

export const RejectReviewModal = ({
  open,
  submitting,
  onCancel,
  onSubmit,
}: RejectReviewModalProps) => {
  const t = useTranslate();
  const [form] = Form.useForm<ReviewRejectIn>();
  const reason = Form.useWatch('reason', form);

  const handleOk = async () => {
    let values: ReviewRejectIn;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    onSubmit(values.reason);
  };

  return (
    <Modal
      open={open}
      title={t('feedback.reviews.actions.confirm_reject')}
      okText={t('feedback.reviews.actions.reject')}
      okButtonProps={{ danger: true, disabled: !reason, loading: submitting }}
      cancelText={t('actions.cancel')}
      cancelButtonProps={{ disabled: submitting }}
      closable={!submitting}
      maskClosable={!submitting}
      onCancel={onCancel}
      onOk={handleOk}
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          name="reason"
          label={t('feedback.reviews.fields.rejection_reason')}
          rules={[{ required: true }]}
        >
          <Select
            placeholder={t(
              'feedback.reviews.actions.reject_reason_placeholder'
            )}
            options={Object.values(ReviewRejectionReason).map((value) => ({
              value,
              label: t(`feedback.reviews.rejection_reasons.${value}`),
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
